class ObjectUtils {
  async sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async waitUntil(
    conditionFunction: () => boolean,
    retryEvery = 100,
    maxWaitTime = 5000,
  ) {
    const startTime = Date.now();
    while (!conditionFunction()) {
      if (Date.now() - startTime > maxWaitTime) {
        throw new Error("waitUntil timed out");
      }
      await this.sleep(retryEvery);
    }
  }
}

export default new ObjectUtils();
